export enum ButtonVariants {
  DEFAULT = "DEFAULT",
  COLUMN = "COLUMN",
}
